module.exports = __webpack_public_path__ + "static/media/uploadIcon.6f249135.webp";